/**
 * The kind of reference chip
 */
export type ReferenceChipKind = 'status' | 'step';

const baseReferenceChipClasses =
  'inline align-baseline rounded-md px-1 py-0.5 font-normal transition-colors duration-200 ease-in-out whitespace-pre-wrap cursor-default select-none';

const statusClasses =
  'bg-info-50 text-info-700 hover:bg-info-100 hover:text-info-800';
const stepClasses =
  'bg-warning-50 text-warning-700 hover:bg-warning-100 hover:text-warning-800';

/**
 * Get the classes for a reference chip based on the kind
 * @param {ReferenceChipKind} kind - The kind of the chip
 * @param {string} extraClassName - Optional additional CSS classes to apply
 * @returns {string} The classes for the chip
 */
export const getReferenceChipClasses = (
  kind: ReferenceChipKind,
  extraClassName = ''
): string => {
  const kindClasses = kind === 'status' ? statusClasses : stepClasses;
  return [baseReferenceChipClasses, kindClasses, extraClassName]
    .filter(Boolean)
    .join(' ');
};
